<template>
  <!-- sign in start -->
  <section class="authentication-form">
    <div class="innerpage-decor">
    </div>
    <div>
      <h2 class="title text-center"><router-link to="/"><img :src='"../../assets/images/efunding-logo.png"' alt="logo-brand"></router-link></h2>
      <div class="card text-center">
        <h3>Silahkan Masuk Untuk Memperbaiki Data Diri Anda</h3>
        <router-link to="/pengajuan-saya?q=Profil">Masuk</router-link>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'RevisionProfile',
}
</script>



// WEBPACK FOOTER //
// src/public/auth/RevisionProfile.vue